<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>AIC ONE - check email</title>
</head>

<body class="login-home background-body">
  <div class="container auth-logo-card-spacing align-items-center d-flex">
    <!-- Logo Section -->
    <div class="logo-section">
      <img
        :src="styleConfig.reset_logo"
        alt="aicone Logo"
        class="logo"
      />

      <div class="user-count d-none">
        <div class="user-dots d-flex">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <span>3k+ people joined us, now it's your turn</span>
      </div>
    </div>

    <div class="sign-in-form">
      <div class="mt-3 text-center">
        <h2 class="text-black fw-bold">Check your email</h2>
        <p class="text-black mb-2">
          We’ve sent a password reset link to
          <strong>{{ email || 'your email' }}</strong>.
        </p>
        <p class="text-muted small">
          If you don’t see it, check your spam folder.
        </p>
      </div>

      <div class="mt-4 text-center" v-if="email">
        <button
          type="button"
          class="btn sign-up-btn btn-dark fw-bold"
          :disabled="is_resend_disabled || countdown > 0"
          @click="resend_email"
        >
          <span v-if="!is_resend_disabled && countdown === 0">
            <i class="fas fa-envelope me-2"></i> Resend email
          </span>
          <span v-else>
            <i class="fas fa-clock me-2"></i> Resend available in {{ countdown }}s
          </span>
        </button>
      </div>

      <div class="mt-3 text-center" v-else>
        <p class="text-muted small mb-2">
          We couldn’t detect the email address. Please go back and enter it again.
        </p>
        <router-link to="/reset" class="btn btn-outline-dark btn-sm">Go to Reset</router-link>
      </div>

      <div class="forgot-password mt-4 text-center">
        <span>
          Back to
          <router-link class="text-danger" to="/">Login</router-link>
        </span>
      </div>
    </div>
  </div>
</body>
